<template functional>
  <v-card flat style="border: 1px solid #ddd;border-radius: 10px;">
    <v-card-title>
      <router-link style="text-decoration:none;color:#000;" :to="{name: 'UserTop', params: {id: props.user.uid}}">
        <v-layout row wrap>
          <v-flex style="position:relative;text-align:left;">
            <v-avatar size="44" style="z-index:10"><v-img :src="props.user.imageurl" :lazy-src="require('@/assets/img/person_icon.png')"/></v-avatar>
            <div style="height:48px;width:48px;border-radius:24px;border:solid 2px #f44336;position:absolute;top:-2px;left:-2px"></div>
          </v-flex>
          <v-flex style="margin-left:12px;padding-top:6px; font-weight:bold;font-size:120%;max-width:250px;text-align:left;">
            {{props.user.displayName}} さんのページへ
          </v-flex>
        </v-layout>
      </router-link>
    </v-card-title>
  </v-card>
</template>

<script>
// import {Tweet} from 'vue-tweet-embed'

export default {
  name: 'UserCard',
  data () {
    return {
    }
  },
  props: {
    user: Object
  },
  computed: {
  },
  filters: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style>
</style>